/*
 * HomeReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */

import produce from 'immer';
import {  ON_NOTIFY, LOADER_STATUS, CHART_INFO, RESET_CHART_INFO, LINE_INFO, RESET_LINE_INFO} from './constants';

// The initial state of the App
export const initialState = {
  chartMsg: '',
  loaderStatus: false,
  lineMsg: ''
  
};

/* eslint-disable default-case, no-param-reassign */
const reportsReducer = (state = initialState, action) =>{
    switch (action.type) {
      case CHART_INFO:
        return {
          ...state,
          chartMsg:action.chartMsg
        }
      case LOADER_STATUS:
        return {
          ...state,
          loaderStatus:action.loaderStatus
        }
      case RESET_CHART_INFO:
        return {
          ...state,
          chartMsg:action.chartMsg,
          lineMsg:action.lineMsg
        }
      case LINE_INFO:
        return {
          ...state,
          lineMsg:action.lineMsg
        }
      case RESET_LINE_INFO:
        return {
          ...state,
          lineMsg:action.lineMsg
        }
      default:
        return state;
      }
    
  };


 

export default reportsReducer;


